'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PZHome = function PZHome(props) {
    var pzGeneralSettings = props.generalSettings;
    var customizationDataAlignRight = {
        transformObject: _defineProperty({}, props.pzPopupViewType, {
            align: 'right'
        })
    };
    var customizationDataAlignCenter = {
        transformObject: _defineProperty({}, props.pzPopupViewType, {
            align: 'center'
        })
    };
    var customizationDataAlignLeft = {
        transformObject: _defineProperty({}, props.pzPopupViewType, {
            align: 'left'
        })
    };
    var imageLi = null;
    //console.log("props.pzPopupUploadImages  ==> ", props.pzPopupUploadImages)
    if (props.popup && Object.keys(props.pzPopupUploadImages).length > 0) {
        var currUploadedImages = {};
        if (props.pzPopupCopyToBoth) {
            currUploadedImages = _extends({}, props.pzPopupUploadImages['outside']);
        } else {
            currUploadedImages = _extends({}, props.pzPopupUploadImages[props.pzPopupViewType]);
        }
        if (Object.keys(currUploadedImages).length > 0) {
            imageLi = Object.keys(currUploadedImages).map(function (imageKey, idx) {
                //console.log("imageKey ", imageKey)
                var imgData = currUploadedImages[imageKey];
                //console.log("imgData ", imgData)
                //console.log("file ", imgData.file)
                var imgTag = '';

                imgData.file && props.HomeComponent.pzGetUploadImage(imgData.file).then(function (imgSrc) {

                    imgTag = '<img src={imgSrc} width="50" height="50" />';
                });

                //let imgSrc = this.props.HomeComponent.pzGetUploadImage(imgData.file);
                return React.createElement(
                    'li',
                    null,
                    imgTag,
                    React.createElement(
                        'span',
                        null,
                        'Image ',
                        parseInt(idx) + 1
                    ),
                    (props.pzPopupViewType == "inside" && !props.pzPopupCopyToBoth || props.pzPopupViewType == "outside") && React.createElement(
                        'a',
                        { onClick: function onClick(e) {
                                e.preventDefault(), props.HomeComponent.pzPopupRemoveImage(e, imgData, imageKey, props.pzPopupViewType);
                            } },
                        ' Remove'
                    )
                );
            });
        }
    }

    return React.createElement(
        'div',
        { className: 'pz pz-main-widget' },
        props.pzPageLoader && React.createElement(
            'div',
            { className: 'pz-loader-cover' },
            React.createElement('div', { className: 'pz-loader' })
        ),
        React.createElement(
            'div',
            { className: 'pz-container' },
            React.createElement(
                'div',
                { className: 'pz-custom-wrapper' },

                //props.popup &&


                React.createElement(
                    'div',
                    { id: 'customization-window', className: 'pz-customization-window  ' + (props.popup ? ' show' : ' hide') },
                    React.createElement(
                        'div',
                        { className: 'pz-create-overlay-cover' },
                        React.createElement(
                            'div',
                            { className: 'pz-l-m-header-title' },
                            'Design your background for the Dye-sub lanyards'
                        ),
                        React.createElement(
                            'div',
                            { className: 'pz-create-overlay' },
                            React.createElement(
                                'button',
                                { className: 'pz-close-overlay-btn', id: 'close-button', onClick: function onClick(e) {
                                        e.preventDefault(), props.HomeComponent.pzClosePopup();
                                    } },
                                React.createElement('i', {
                                    className: 'fa fa-times' })
                            ),
                            React.createElement(
                                'div',
                                { className: 'pz-overlay-container' },
                                React.createElement(
                                    'div',
                                    { className: 'pz-l-th-detail' },
                                    'Zoom view of the lanyards ( 36 in. )'
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'canvas-container', id: 'pz-overlay-container-canvas' },
                                    React.createElement('div', { className: 'canvas-container', id: 'pz-overlay-container-canvas' })
                                )
                            ),
                            React.createElement(
                                'div',
                                { className: 'pz-apply-overlay-section' },
                                React.createElement(
                                    'div',
                                    { className: 'pz-overlay-info-sec' },
                                    React.createElement(
                                        'div',
                                        { className: 'pz-l-upload' },
                                        React.createElement(
                                            'h4',
                                            { className: 'pz-l-side-title' },
                                            'Upload Image'
                                        ),
                                        React.createElement(
                                            'div',
                                            { className: 'pz-upload-wrapper' },
                                            React.createElement(
                                                'div',
                                                { className: 'pz-upload-control' },
                                                React.createElement(
                                                    'div',
                                                    { className: 'pz-upload-content' },
                                                    React.createElement(
                                                        'p',
                                                        { className: 'pz-info-text' },
                                                        'Choose...'
                                                    ),
                                                    React.createElement(
                                                        'p',
                                                        { className: 'pz-browse-text' },
                                                        React.createElement('i', { className: 'fa fa-cloud-upload' }),
                                                        ' Browse'
                                                    )
                                                ),
                                                React.createElement('input', { type: 'file', className: 'pz-upload-file', onChange: function onChange(e) {
                                                        e.preventDefault(), props.HomeComponent.pzPopupUploadImage(e);
                                                    } })
                                            ),
                                            React.createElement(
                                                'div',
                                                { className: 'pz-upload-error' },
                                                props.pzPopupUploadImgErrorMsg
                                            ),
                                            props.pzPopupUploadDPIMsg == 1 && React.createElement(
                                                'p',
                                                { className: 'pz-upload-warning' },
                                                'The image you uploaded may be of low resolution, which may impact the quality of the print on the lanyard. The customer service representative will contact you to request a better image quality.'
                                            ),
                                            props.popup && React.createElement(
                                                'div',
                                                { className: 'pz-uploadedImages' },
                                                React.createElement(
                                                    'ul',
                                                    { 'class': 'pz-upld-list' },
                                                    imageLi
                                                )
                                            )
                                        ),
                                        (props.pzPopupViewType == "inside" && !props.pzPopupCopyToBoth || props.pzPopupViewType == "outside") && React.createElement(
                                            'label',
                                            { className: 'pz-cust-checkbox' },
                                            'Repeat the image',
                                            React.createElement('input', { type: 'checkbox', value: 'outside', checked: '' + (props.pzPopupViewBasedUploadType && props.pzPopupViewBasedUploadType[props.pzPopupViewType] == "repeat" ? 'checked' : ''), onClick: function onClick(e) {
                                                    props.HomeComponent.pzPopupRepeat(e);
                                                } }),
                                            React.createElement('span', { className: 'checkmark' })
                                        )
                                    )
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'pz-overlay-info-sec' },
                                    React.createElement(
                                        'div',
                                        { className: 'pz-l-side-select' },
                                        React.createElement(
                                            'h4',
                                            { className: 'pz-l-side-title' },
                                            'upload Image position'
                                        ),
                                        React.createElement(
                                            'label',
                                            { className: 'pz-cust-rdio' },
                                            'Front Side',
                                            React.createElement('input', { type: 'radio', className: 'view_type1', name: 'view_type', id: 'outside', value: 'outside', checked: '' + (props.pzPopupViewType == 'outside' ? 'checked' : ''), onClick: function onClick(e) {
                                                    props.HomeComponent.pzPopupSwitchViewType(e, 'outside');
                                                } }),
                                            React.createElement('span', { className: 'checkmark' })
                                        ),
                                        !props.pzPopupCopyToBoth && React.createElement(
                                            'label',
                                            { className: 'pz-cust-rdio' },
                                            'Back Side',
                                            React.createElement('input', { type: 'radio', className: 'view_type1', name: 'view_type', id: 'inside', value: 'inside', checked: '' + (props.pzPopupViewType == 'inside' ? 'checked' : ''), onClick: function onClick(e) {
                                                    props.HomeComponent.pzPopupSwitchViewType(e, 'inside');
                                                } }),
                                            React.createElement('span', { className: 'checkmark' })
                                        ),
                                        props.pzPopupViewType == "outside" && React.createElement(
                                            'label',
                                            { className: 'pz-cust-checkbox', onClick: function onClick(e) {
                                                    e.preventDefault();props.HomeComponent.pzPopupCopyBoth(e);
                                                } },
                                            'Apply the design to backside',
                                            React.createElement('input', { type: 'checkbox', checked: '' + (props.pzPopupCopyToBoth == true ? 'checked' : '') }),
                                            React.createElement('span', { className: 'checkmark' })
                                        )
                                    )
                                ),
                                !props.pzPopupCopyToBoth && React.createElement(
                                    'div',
                                    { className: 'pz-overlay-info-sec' },
                                    React.createElement(
                                        'div',
                                        { className: 'pz-l-align' },
                                        React.createElement(
                                            'h4',
                                            { className: 'pz-l-side-title' },
                                            'Align image'
                                        ),
                                        React.createElement(
                                            'label',
                                            { className: 'pz-cust-rdio' },
                                            'Left',
                                            React.createElement('input', { type: 'radio', name: 'image_alignment', value: 'left', onClick: function onClick(e) {
                                                    props.promizeTwoDObj.updateComponent(customizationDataAlignLeft);
                                                } }),
                                            React.createElement('span', { className: 'checkmark' })
                                        ),
                                        React.createElement(
                                            'label',
                                            { className: 'pz-cust-rdio' },
                                            'Right',
                                            React.createElement('input', { type: 'radio', name: 'image_alignment', value: 'right', onClick: function onClick(e) {
                                                    props.promizeTwoDObj.updateComponent(customizationDataAlignRight);
                                                } }),
                                            React.createElement('span', { className: 'checkmark' })
                                        ),
                                        React.createElement(
                                            'label',
                                            { className: 'pz-cust-rdio' },
                                            'Center',
                                            React.createElement('input', { type: 'radio', name: 'image_alignment', value: 'center', onClick: function onClick(e) {
                                                    props.promizeTwoDObj.updateComponent(customizationDataAlignCenter);
                                                } }),
                                            React.createElement('span', { className: 'checkmark' })
                                        )
                                    )
                                ),
                                React.createElement(
                                    'div',
                                    { className: 'pz-overlay-info-sec' },
                                    React.createElement(
                                        'div',
                                        { className: 'pz-l-controls' },
                                        React.createElement(
                                            'h4',
                                            { className: 'pz-l-side-title' },
                                            'View Controls'
                                        ),
                                        React.createElement(
                                            'div',
                                            { className: 'pz-text-slider' },
                                            React.createElement(
                                                'span',
                                                null,
                                                'Zoom'
                                            ),
                                            React.createElement('input', { type: 'range', id: 'spacing', min: '0', max: '28', value: props.pzPopupZoomSliderDefault, onChange: function onChange(e) {
                                                    e.preventDefault(), props.HomeComponent.pzPopupZoomSlider(e);
                                                } })
                                        ),
                                        React.createElement(
                                            'div',
                                            { className: 'pz-text-slider' },
                                            React.createElement(
                                                'span',
                                                null,
                                                'Move ',
                                                React.createElement(
                                                    'span',
                                                    null,
                                                    '( Left / Right )'
                                                )
                                            ),
                                            React.createElement('input', { type: 'range', id: 'spacing', min: '-40', max: '40', value: props.pzPopupPanSliderDefault, onChange: function onChange(e) {
                                                    e.preventDefault(), props.HomeComponent.pzPopupPanSlider(e);
                                                } })
                                        )
                                    )
                                )
                            )
                        ),
                        React.createElement(
                            'div',
                            { className: 'pz-cp-thumb-cover' },
                            React.createElement(
                                'div',
                                { 'class': 'pz-l-th-detail' },
                                'Full view of the lanyards ( 36 in. )'
                            ),
                            React.createElement('div', { className: 'pz-cp-thumb', id: 'pz-cp-thumb' })
                        ),
                        React.createElement(
                            'div',
                            { className: 'pz-cp-actions' },
                            React.createElement(
                                'button',
                                { id: 'applyToLanyard', className: 'pz-overlay-cancel-btn', onClick: function onClick(e) {
                                        e.preventDefault(), props.HomeComponent.pzClosePopup();
                                    } },
                                ' Cancel'
                            ),
                            React.createElement(
                                'button',
                                { id: 'applyToLanyard', className: 'pz-overlay-apply-btn', onClick: function onClick(e) {
                                        e.preventDefault(), props.HomeComponent.pzPopupApplyToLanyard();
                                    } },
                                'Apply'
                            )
                        )
                    )
                ),
                React.createElement(
                    'div',
                    { className: props.fullScreen == 1 ? " pz-img-full " : props.fullScreen == 2 ? " pz-img-off " : " pz-image-section " },
                    React.createElement('div', { id: 'pz-left-container', className: 'pz-image-container' }),
                    pzGeneralSettings && pzGeneralSettings.length > 0 && pzGeneralSettings.map(function (settings, index) {
                        if (settings && settings.settings_type == "common" && settings.promize_settings[0]) {
                            var setting = settings.promize_settings[0];
                            if (setting.reference_id == 2 && setting.reference_name.toLowerCase() == "yes") {
                                return React.createElement(
                                    React.Fragment,
                                    null,
                                    React.createElement('div', { id: 'pz-image-full-screen', className: 'pz-image-fullscreeen-control', onClick: function onClick(e) {
                                            e.preventDefault(), props.HomeComponent.pzToggleFullScreen();
                                        } }),
                                    React.createElement(
                                        'div',
                                        { 'class': 'pz-image-rotate-control', id: 'pz-image-rotate-control' },
                                        React.createElement(
                                            'button',
                                            { className: 'pz-zoom-in', id: 'pz-auto-rotate', title: 'Auto Rotate', onClick: function onClick(e) {
                                                    e.preventDefault(), props.promizeThreeDObj.updateView({ view: 'toggleAutoRotate' });
                                                } },
                                            React.createElement('i', { className: 'fa fa-minus' })
                                        )
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'pz-image-pan-controls', id: 'pz-image-pan-controls' },
                                        React.createElement(
                                            'div',
                                            { className: 'pz-text-slider' },
                                            React.createElement('input', { type: 'range', id: 'pad-slider', title: 'Pan up and down slider', value: props.panSlider, min: '-50', max: '50', onChange: function onChange(e) {
                                                    e.preventDefault(), props.HomeComponent.panSlider(e);
                                                } })
                                        )
                                    ),
                                    React.createElement(
                                        'div',
                                        { className: 'pz-default-zoom', id: 'pz-image-rotate-control' },
                                        React.createElement(
                                            'button',
                                            { className: 'pz-pan-down', id: 'pan-up', title: 'Reset Zoom', onClick: function onClick(e) {
                                                    e.preventDefault(), props.promizeThreeDObj.updateView({ view: 'reset-view' });
                                                } },
                                            React.createElement('i', { 'class': 'fa fa-bullseye' })
                                        )
                                    )
                                );
                            }
                            if (setting.reference_id == 1 && setting.reference_name.toLowerCase() == "yes") {
                                return React.createElement(
                                    'div',
                                    { className: 'pz-image-zoom-controls', id: 'pz-image-zoom-controls' },
                                    React.createElement(
                                        'button',
                                        { className: 'pz-zoom-in', id: 'pz-zoom-in', title: 'Zoom In', onClick: function onClick(e) {
                                                e.preventDefault(), props.promizeThreeDObj.updateView({ view: 'zoomIn' });
                                            } },
                                        React.createElement('i', { className: 'fa fa-plus' })
                                    ),
                                    React.createElement(
                                        'button',
                                        { className: 'pz-zoom-in', id: 'pz-zoom-out', title: 'Zoom Out', onClick: function onClick(e) {
                                                e.preventDefault(), props.promizeThreeDObj.updateView({ view: 'zoomOut' });
                                            } },
                                        React.createElement('i', { className: 'fa fa-minus' })
                                    )
                                );
                            }
                            if (setting.reference_id == 3 && setting.reference_name.toLowerCase() == "yes") {
                                return React.createElement(
                                    'div',
                                    { className: 'pz-undo-redo-controls' },
                                    React.createElement(
                                        'button',
                                        { className: 'pz-zoom-in', title: 'Undo', onClick: function onClick(e) {
                                                e.preventDefault(), props.HomeComponent.pzUndoRedoHandler('UNDO');
                                            } },
                                        React.createElement(
                                            'svg',
                                            { xmlns: 'http://www.w3.org/2000/svg', width: '50', height: '31.25', viewBox: '0 0 50 31.25' },
                                            React.createElement('path', { d: 'M12.5,134.587H34.375v-3.125H12.5a9.375,9.375,0,0,1,0-18.75H42.187v6.25L50,111.15l-7.812-7.813v6.25H12.5a12.5,12.5,0,1,0,0,25Z',
                                                transform: 'translate(0 -103.338)' })
                                        )
                                    ),
                                    React.createElement(
                                        'button',
                                        { className: 'pz-zoom-in', title: 'Redo', onClick: function onClick(e) {
                                                e.preventDefault(), props.HomeComponent.pzUndoRedoHandler('REDO');
                                            } },
                                        React.createElement(
                                            'svg',
                                            { xmlns: 'http://www.w3.org/2000/svg', width: '50', height: '31.25', viewBox: '0 0 50 31.25' },
                                            React.createElement('path', { d: 'M37.5,103.337H15.625v3.125H37.5a9.375,9.375,0,0,1,0,18.75H7.812v-6.25L0,126.774l7.812,7.812v-6.25H37.5a12.5,12.5,0,1,0,0-25Z', transform: 'translate(0 -103.338)' })
                                        )
                                    )
                                );
                            }
                        }
                    })
                ),
                React.createElement(
                    'div',
                    { className: props.fullScreen == true ? "pz-customizer-section pz-custom-hide" : "pz-customizer-section" },
                    React.createElement(
                        'div',
                        { className: 'pz-customizer-wrapper' },
                        React.createElement(
                            'div',
                            { className: 'pz-custom-item-wrapper' },
                            React.createElement(
                                'div',
                                { className: 'pz-custom-item-menu' },
                                React.createElement(PromizeSection, props)
                            ),
                            React.createElement(
                                'div',
                                { className: 'pz-custom-content-wrapper' },
                                React.createElement(PromizeTab, props)
                            )
                        )
                    )
                ),
                props.pzActiveOptionHover && props.pzActiveOptionHover.text && React.createElement(
                    'div',
                    { 'class': 'pz-hover', style: { display: 'block', top: props.pzActiveOptionHover.top, left: props.pzActiveOptionHover.left } },
                    React.createElement(
                        'div',
                        null,
                        ' ',
                        props.pzActiveOptionHover.text
                    )
                )
            )
        ),
        React.createElement(
            'div',
            { className: 'pz-cart-container' },
            React.createElement(PromizeCart, props)
        ),
        props.pzDialogPopup && React.createElement(
            'div',
            { className: 'pz-reset-popup active', role: 'dialog' },
            React.createElement(
                'div',
                { className: 'pz-reset-dialog' },
                React.createElement(
                    'div',
                    { className: 'pz-reset-content' },
                    React.createElement(
                        'p',
                        null,
                        'Do you want clear all the changes you made?'
                    ),
                    React.createElement(
                        'div',
                        { className: 'pz-reset-action' },
                        React.createElement(
                            'button',
                            { onClick: function onClick(e) {
                                    e.preventDefault(), props.HomeComponent.pzDialogPopupHandler('cancel');
                                }, className: 'pz-reset-btn-n' },
                            'Cancel'
                        ),
                        React.createElement(
                            'button',
                            { onClick: function onClick(e) {
                                    e.preventDefault(), props.HomeComponent.pzDialogPopupHandler('continue');
                                }, className: 'pz-reset-btn-y' },
                            'Continue'
                        )
                    )
                )
            )
        ),
        props.pzErrorDialogPopup && React.createElement(
            'div',
            { className: 'pz-reset-popup active', role: 'dialog' },
            React.createElement(
                'div',
                { className: 'pz-reset-dialog' },
                React.createElement(
                    'div',
                    { className: 'pz-reset-content' },
                    React.createElement(
                        'p',
                        null,
                        'Sorry! You cannot add the product to the cart without customizing. Text/image is required to continue.'
                    ),
                    React.createElement(
                        'div',
                        { className: 'pz-reset-action' },
                        React.createElement(
                            'button',
                            { onClick: function onClick(e) {
                                    e.preventDefault(), props.HomeComponent.pzErrorDialogPopupHandler('continue');
                                }, className: 'pz-reset-btn-y' },
                            'OK'
                        )
                    )
                )
            )
        )
    );
};